import RelatedArticleEditing from './related-article-editing';
import { Plugin } from '@ckeditor/ckeditor5-core';
import './styles.css';
class RelatedArticleUI extends Plugin {
    init() { }
}
export default class RelatedArticle extends Plugin {
    static get requires() {
        return [RelatedArticleEditing, RelatedArticleUI];
    }
}
